module.exports = __webpack_public_path__ + "media/images/fbcalls/kraken-21e951d36690c459ce0eecb5410a870d.jpg";